import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CereriComponent } from './cereri.component';
import { MaterialModule } from 'src/app/material.module';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { SubsemnatComponent } from './cereri-detalii/subsemnat/subsemnat.component';
// import { MesagerieComponent } from './cereri-detalii/mesagerie/mesagerie.component';
import { CerereDetaliiSabloaneComponent } from './cereri-detalii/sabloane/cerere-detalii-sabloane.component';
import { ActualizareCerereComponent } from './cereri-detalii/actualizare-cerere/actualizare-cerere.component';
import { ActiuniCerereCardComponent } from './cereri-detalii/actiuni-cerere-card/actiuni-cerere-card.component';
// import { DocumenteCerereComponent } from './cereri-detalii/documente-cerere/documente-cerere.component';
// import { IstoricCerereComponent } from './cereri-detalii/istoric-cerere/istoric-cerere.component';
import { InformatiiAditionaleComponent } from './cereri-detalii/informatii-aditionale/informatii-aditionale.component';
import { ModalInchidereLucrareComponent } from './cereri-detalii/modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { AddSemnatariComponent } from './cereri-detalii/add-semnatari/add-semnatari.component';
import { CerereValidareComponent } from './cereri-detalii/cerere-validare/cerere-validare.component';
import { RegistruValabilityComponent } from './cereri-detalii/registru-valability/registru-valability.component';
import { DocumentGenerabilComponent } from './cereri-detalii/document-generabil/document-generabil.component';
import { EditDocumentOficialComponent } from './cereri-detalii/document-generabil/edit-document-oficial/edit-document-oficial.component';
import { IstoricDocumentGenerabilComponent } from './cereri-detalii/document-generabil/istoric-document-generabil/istoric-document-generabil.component';
import { UpdateGenerabilValabilityComponent } from './cereri-detalii/document-generabil/update-generabil-valability/update-generabil-valability.component';
import { CereriIstoricComponent } from './cereri-detalii/cereri-istoric/cereri-istoric.component';
import { CereriAsigneazaComponent } from './cereri-asigneaza/cereri-asigneaza.component';
import { CereriStatusComponent } from './cereri-status/cereri-status.component';
import { CerereFunctiiAssignmentComponent } from './cereri-detalii/cerere-functii-assignment/cerere-functii-assignment.component';
import { DocumentAssignmentComponent } from './cereri-detalii/document-assignment/document-assignment.component';
import { EtapeDecontareComponent } from './cereri-detalii/etape-decontare/etape-decontare.component';
import { ActivityScheduleModule } from '../activity-schedule/activity-schedule.module';
import { MotivRefuzDialogComponent } from './cereri-detalii/motiv-refuz-dialog/motiv-refuz-dialog.component';
import { PreValidareCerereComponent } from './cereri-detalii/pre-validare-cerere/pre-validare-cerere.component';
import { CereriAlocaVerificatorComponent } from './cereri-aloca-verificator/cereri-aloca-verificator.component';
import { AjutoareStatsBarComponent } from './ajutoare-stats-bar/ajutoare-stats-bar.component';
import { AjutoareStatsModalComponent } from './ajutoare-stats-bar/ajutoare-stats-modal/ajutoare-stats-modal.component';

@NgModule({
    declarations: [
        CereriComponent,
        CereriDetaliiComponent,
        CereriDetaliiComponent,
        SubsemnatComponent,
        // MesagerieComponent,
        CerereDetaliiSabloaneComponent,
        ActualizareCerereComponent,
        ActiuniCerereCardComponent,
        // DocumenteCerereComponent,
        // IstoricCerereComponent,
        InformatiiAditionaleComponent,
        ModalInchidereLucrareComponent,
        AddSemnatariComponent,
        CerereValidareComponent,
        RegistruValabilityComponent,
        DocumentGenerabilComponent,
        EditDocumentOficialComponent,
        IstoricDocumentGenerabilComponent,
        UpdateGenerabilValabilityComponent,
        CereriIstoricComponent,
        CereriAsigneazaComponent,
        CereriStatusComponent,
        CerereFunctiiAssignmentComponent,
        DocumentAssignmentComponent,
        EtapeDecontareComponent,
        MotivRefuzDialogComponent,
        PreValidareCerereComponent,
        CereriAlocaVerificatorComponent,
        AjutoareStatsBarComponent,
        AjutoareStatsModalComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        DataTablesModule,
        PipesModule,
        DragDropModule,
        ActivityScheduleModule
    ],
    providers: [
        // Import activity schedule services needed by the widget
    ],
    exports: [CereriComponent],
})
export class CereriModule { }
